import { css } from '@emotion/react';
import { Button } from '@core/components/Button';
import { CONFIRM_PRIMARY_BTN, CONFIRM_SECONDARY_BTN, CONFIRM_WRAPPER, } from '@core/components/testIds';
import { useContextTranslation } from '@core/i18n';
import { PlayerModal } from '@embed/components/VideoPlayer/Player3/components/PlayerModal';
import { Message, Wrapper } from './Confirm.styles';
import Modal from './index';
/**
 *
 */
export const Confirm = ({ confirmButtonText, cancelButtonText, onConfirmClick, onCancelClick, message, borderRadius, }) => {
    const { t } = useContextTranslation();
    return (<PlayerModal branding={false}>
      <Modal.Menu>
        <Wrapper data-testid={CONFIRM_WRAPPER} css={borderRadius
            ? css `
                  border-radius: ${borderRadius}px;
                `
            : undefined}>
          <Message>{message}</Message>
          <Button onClick={onConfirmClick} data-testid={CONFIRM_PRIMARY_BTN} variant="primary" style={{
            '--button-border-radius': 'var(--player-button-border-radius)',
        }}>
            {confirmButtonText || t('OK')}
          </Button>
          <Button onClick={onCancelClick} data-testid={CONFIRM_SECONDARY_BTN} variant="outlined" style={{
            '--button-border-radius': 'var(--player-button-border-radius)',
        }}>
            {cancelButtonText || t('Cancel')}
          </Button>
        </Wrapper>
      </Modal.Menu>
    </PlayerModal>);
};
export default Confirm;
